import { useEffect } from "react";
import { useReducedMotion } from "framer-motion";
import Lenis from "lenis";

// Smooth scrolling is skipped entirely for reduced-motion users.
export const useLenis = () => {
  const reduced = useReducedMotion();
  useEffect(() => {
    if (reduced) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, [reduced]);
};
